import { render } from "./OptionalField.vue?vue&type=template&id=6508f168&scoped=true"
import script from "./OptionalField.vue?vue&type=script&lang=js"
export * from "./OptionalField.vue?vue&type=script&lang=js"

import "./OptionalField.vue?vue&type=style&index=0&id=6508f168&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6508f168"]])

export default __exports__